import React from 'react';

import Typography from '~/components/core/Atomic/Typography';

import { PERFORMANCE_QA } from '../../../../../../../Types';
import { AUTOMATIC_TYPE, PAYMENTS_CATEGORY, TIMELINESS_CATEGORY } from '../../constants';
import { getPerformanceQuestions } from '../../utils';
import Questions from '../Questions';

import styles from '../sections.module.scss';

const TIMELINESS_QUESTIONS = getPerformanceQuestions(AUTOMATIC_TYPE, TIMELINESS_CATEGORY);
const PAYMENTS_QUESTIONS = getPerformanceQuestions(AUTOMATIC_TYPE, PAYMENTS_CATEGORY);

const Automatic = () => (
  <div>
    <Typography display="block" className={styles.sectionTitle}>
      Select automatic questions by category. The answers will be automatically populated from data in the system.
    </Typography>
    <Questions questions={TIMELINESS_QUESTIONS} categoryName={PERFORMANCE_QA.CATEGORIES.TIMELINESS.desc} />
    <Questions questions={PAYMENTS_QUESTIONS} categoryName={PERFORMANCE_QA.CATEGORIES.PAYMENTS.desc} />
  </div>
);

export default Automatic;
